import * as CollapsiblePrimitive from "@radix-ui/react-collapsible"
import { AnimatePresence, motion } from "framer-motion"
import { cn } from "@/lib/utils"

function Collapsible({
  ...props
}) {
  return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />;
}

function CollapsibleTrigger({
  ...props
}) {
  return (<CollapsiblePrimitive.CollapsibleTrigger data-slot="collapsible-trigger" {...props} />);
}

function CollapsibleContent({
  ...props
}) {
  return (<CollapsiblePrimitive.CollapsibleContent data-slot="collapsible-content" {...props} />);
}

function AnimatedCollapsibleContent({
  open,
  className,
  children,
}) {
  return (
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          data-slot="collapsible-content"
          initial={{ height: 0 }}
          animate={{ height: "auto" }}
          exit={{ height: 0 }}
          transition={{
            height: { duration: 0.2, ease: "easeOut" }
          }}
          className={cn("overflow-hidden", className)}
        >
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{
              opacity: { duration: 0.15, ease: "easeOut" },
              y: { duration: 0.15, ease: "easeOut" }
            }}
          >
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent, AnimatedCollapsibleContent }
